export const DRIVE_OPTIONS = [
  { key: 'google-drive', label: 'Google Drive' },
  { key: 'one-drive', label: 'One Drive' },
  { key: 'self-drive', label: 'Self Drive' },
];

export function getDriveOption(key) {
  return DRIVE_OPTIONS.find((item) => item.key === key) || DRIVE_OPTIONS[0];
}

export function buildDriveRequestPayload(tenantId, driveType, extraData = {}) {
  return {
    tenant_id: tenantId,
    drive_type: driveType,
    client_id: extraData.clientId || extraData.client_id || '',
    client_secret: extraData.clientSecret || extraData.client_secret || '',
    access_key: extraData.accessKey || extraData.access_key || '',
    access_token: extraData.accessToken || extraData.access_token || '',
  };
}

